import React from 'react'

import ListItem from './ProjectFileListItem'

const ProjectFilesList = (props) => {

    return (
        <div className="d-flex flex-column">
            {
                props.files.map((file, index) => <ListItem key={index} {...file}/>)
            }
        </div>
    )

}

export default ProjectFilesList